import axios from "axios";
import { resolve } from "./resolve";
import { API_AUTH_URL } from "../constants/consts";
import { getExchangeHeaders } from "./helpers";

export interface ReservationAllowanceResponse {
  is_allow_reservation: boolean;
}

export const fetchReservationAllowance = async (): Promise<ReservationAllowanceResponse> => {
  const URL = `${API_AUTH_URL}/users/get_is_allow_reservation`;
  
  const response = await resolve(
    axios.get(URL, {
      headers: getExchangeHeaders(),
    }).then((res) => res)
  );

  return response.data.data;
};
